'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tooltip = require('../utils/tooltip.js');

var generateSeriesData = function (data, names, colors) {
    return data.map(function (datum, i) { return ({
        name: names[i],
        y: datum,
        color: colors[i],
    }); });
};
var generateSeries = function (data, outerRadius) { return [
    {
        type: 'pie',
        size: outerRadius + "%",
        showInLegend: true,
        dataLabels: {
            enabled: false,
        },
        data: data,
    },
]; };
var generateOptions = function (options) {
    var legend = options.legend, height = options.height, values = options.values, titles = options.titles, colors = options.colors, outerRadius = options.outerRadius, tooltipFormatter = options.tooltipFormatter;
    return {
        title: { text: '' },
        legend: legend,
        chart: { height: height },
        series: generateSeries(generateSeriesData(values, titles, colors), outerRadius),
        credits: {
            enabled: false,
        },
        tooltip: {
            formatter: function () {
                return tooltip.xOnlyChart(this, tooltipFormatter);
            },
        },
    };
};

exports.generateOptions = generateOptions;
exports.generateSeries = generateSeries;
exports.generateSeriesData = generateSeriesData;
